import React from "react";
import styled, { css } from "styled-components";
const Wrapper = styled.div<{ stretched: boolean }>`
	display: flex;
	justify-content: ${(props) => (props.stretched ? "space-between" : "flex-start")};
	/* justify-content: space-between */
`;
const KeyText = styled.p<{ minKeyWidth: boolean }>`
	font-weight: 700;
	${(props) =>
		props.minKeyWidth &&
		css`
			min-width: 80px;
		`};
`;

const Text = styled.p``;

const TextKeyValue: React.FC<{ keyText: string; value: string; className?: string; stretched?: boolean; minKeyWidth?: boolean }> = ({
	keyText,
	value,
	className,
	stretched = false,
	minKeyWidth = true
}) => {
	return (
		<Wrapper className={className} stretched={stretched}>
			<KeyText minKeyWidth={minKeyWidth}>{keyText}</KeyText>
			<Text>{value}</Text>
		</Wrapper>
	);
};

export default TextKeyValue;
